import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { Icon } from "@iconify/react";
import { WebBannerImages } from "./WebBannerImages/WebBannerImages";
import { MobileHomepageBannerSlider } from "./MobileHomepageBannerSlider/MobileHomepageBannerSlider";
import { WebFooterImages } from "./WebFooterImages/WebFooterImages";

export const Banners = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const id = query?.get("id");

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/magp/others?activeTab=banners&subActiveTab=webBannerImages`, {
        replace: true,
      });
    }
  }, [navigate, query]);

  const items = [
    {
      label: "Web Banner Images",
      key: "webBannerImages",
      children: <WebBannerImages/>
    },
    {
      label: "Mobile Homepage Banner Slider",
      key: "mobileHomepageBannerSlider",
      children: <MobileHomepageBannerSlider/>
    },
    {
      label: "Web Footer Images",
      key: "webFooterImages",
      children: <WebFooterImages/>
    }
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
